import { DurationInput as GammaDurationInput } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type DurationInputProps = React.ComponentProps<typeof GammaDurationInput>

type Props = Omit<DurationInputProps, 'selectValue' | 'missingLabel' | 'locale'> & {
  missingLabel?: string
}

const DurationInput = ({ missingLabel, ...props }: Props) => (
  <GammaDurationInput
    {...props}
    missingLabel={missingLabel ?? i18n.t('common.missing_field')}
    selectValue={i18n.t('common.select')}
    locale={i18n.locale}
  />
)

export default DurationInput
